import { Typography, Box, Button } from "@mui/material";
import { useStyles } from "./styles";
import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import constants from "../../constants/constants.json";
import { useNavigate } from "react-router-dom";

export default function Emptystate({
  title,
  message,
  isNavbarOpen,
  isErrorPage = false,
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const classes = useStyles({ theme, isNavbarOpen });
  return (
    <Box className={classes.emptyStateWrapper}>
      <Box sx={{ px: 4, py: 2, boxShadow: 24 }} className={classes.wrapper}>
        <Box className={classes.textWrapper}>
          <Box>
            <Typography
              data-testid="emptyStateTitle"
              className={classes.text}
              variant="h5"
            >
              {title || ""}
            </Typography>
          </Box>
          <Box>
            <Typography
              data-testid="emptyStateMessage"
              className={classes.text}
              variant="body2"
            >
              {message || ""}
            </Typography>
          </Box>
          {isErrorPage && (
            <Box>
              <Button
                data-testid={"home-btn"}
                onClick={() => navigate("/")}
                className={classes.homePageBtn}
              >
                {constants.goToHomePage}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

Emptystate.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  isNavbarOpen: PropTypes.bool,
  isErrorPage: PropTypes.bool,
};
